import React, { useState } from "react";
import { Row, Col } from "@themesberg/react-bootstrap";
import StaffLoginForm from "./StaffLoginForm";
import OwneesClubLogo from "../../../assets/img/Owners-Club-Logo.png"
import LogininBgImage from "../../../assets/img/loginBgImage.png"


export default function LoginPage() {
  const [loginType, setLoginType] = useState("superAdmin");

  const switchToStaff = () => setLoginType("staff");
  const switchToSuperAdmin = () => setLoginType("superAdmin");

  return (
    <main className="vh-100 d-flex position-relative overflow-hidden" style={{
      flex: 2,
    }}>
      
      {/* Blurred background layer */}
      <div style={{
        position: "absolute",
        top: "-10px",
        left: "-10px",
        right: "-10px",
        bottom: "-10px",
        background: "linear-gradient(to bottom, #ffffff 0%, #f4e5ff 25%, #e7cfff 100%)"        // backgroundImage: `url(${LogininBgImage})`,
       
      }} />

      <div className="text-center" style={{ position: "absolute", zIndex: 2 }}>
        <img src={OwneesClubLogo} className="loginLogo" />
      </div>

      {/* Right side: login form */}
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          flex: 2,
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          className="shadow  p-5 rounded bg-white"
          style={{ width: "100%", maxWidth: "600px", border: "1px solid #E5E7EB" }}
        >

          {/* <h2 className="fw-bold">Welcome back!</h2>
          <h4 className="text-muted ">Please Login </h4> */}
          <StaffLoginForm onSwitchToSuperAdmin={switchToSuperAdmin} />
        </div>
      </div>
    </main>
  );
}

